import { MatSnackBar } from '@angular/material/snack-bar';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}
private currentSnackBarRef: any;
  openSnackBar(message: string): void {
    this.openSnackBarWithAction(message, '✕');
  }

  openSnackBarWithAction(
    message: string,
    action: string,
    type: 'success' | 'error' = 'success'
  ): void {
    this.snackBar.open(message, action, {
      duration: 4000,
      horizontalPosition: 'start',
      verticalPosition: 'top',
      panelClass:
        type === 'success' ? ['snack-bar-success'] : ['snack-bar-error'],
    });
  }

/* openPersistentSnackBarWithoutAction(
  message: string,
  type: 'success' | 'error' = 'error'
): void {
  // If a snackbar is already open, don't open a new one
  if (this.currentSnackBarRef) {
    return;
  }

this.snackBar.open(message, '', {
  duration: undefined,
  horizontalPosition: 'start',
  verticalPosition: 'top',
  panelClass: ['custom-snackbar-pane', type === 'success' ? 'snack-bar-success' : 'snack-bar-error']
});



}

dismissCurrentSnackBar(): void {
  if (this.currentSnackBarRef) {
    this.currentSnackBarRef.dismiss();
    this.currentSnackBarRef = null;
  }
} */
}


